export enum ElementType {
  Date = 'date',
  DateTime = 'datetime',
  Time = 'time',
  Button = 'button',
  CloseObservationPeriod = 'close_observation_period',
  DicomButton = 'dicom_button',
  Randomization = 'randomization',
  AdverseEvent = 'adverse_event',
  CheckboxMultiple = 'checkbox_multiple',
  SelectMultiple = 'select_multiple',
  Collection = 'collection',
  DataGrid = 'data_grid',
  Table = 'table',
  Divider = 'divider',
  DrugAllocation = 'drug_allocation',
  File = 'file',
  Number = 'number',
  Range = 'range',
}

const typeGroups = {
  date: new Set([
    ElementType.Date,
    ElementType.DateTime,
    ElementType.Time,
  ]),
  button: new Set([
    ElementType.Button,
    ElementType.CloseObservationPeriod,
    ElementType.DicomButton,
    ElementType.Randomization,
  ]),
  collection: new Set([
    ElementType.AdverseEvent,
    ElementType.Collection,
    ElementType.DataGrid,
    ElementType.Table,
  ]),
  functional: new Set([
    ElementType.Button,
    ElementType.CloseObservationPeriod,
    ElementType.DicomButton,
    ElementType.File,
    ElementType.Randomization,
  ]),
  individuallySaved: new Set([
    ElementType.AdverseEvent,
    ElementType.Button,
    ElementType.CloseObservationPeriod,
    ElementType.DataGrid,
    ElementType.DicomButton,
    ElementType.Divider,
    ElementType.DrugAllocation,
    ElementType.File,
    ElementType.Randomization,
    ElementType.Table,
  ]),
  multiple: new Set([
    ElementType.CheckboxMultiple,
    ElementType.SelectMultiple,
  ]),
  number: new Set([
    ElementType.Number,
    ElementType.Range,
  ]),
  ahistorical: new Set([
    ElementType.AdverseEvent,
    ElementType.Button,
    ElementType.CloseObservationPeriod,
    ElementType.Collection,
    ElementType.DataGrid,
    ElementType.DicomButton,
    ElementType.Divider,
    ElementType.Randomization,
    ElementType.Table,
  ]),
  table: new Set([
    ElementType.AdverseEvent,
    ElementType.DataGrid,
    ElementType.Table,
  ]),
  standalone: new Set([
    ElementType.AdverseEvent,
    ElementType.Button,
    ElementType.CloseObservationPeriod,
    ElementType.Collection,
    ElementType.DataGrid,
    ElementType.DicomButton,
    ElementType.Divider,
    ElementType.DrugAllocation,
    ElementType.File,
    ElementType.Randomization,
    ElementType.Table,
  ]),
};

export class ElementTypeUtils {
  public static isInGroup(type: string, group: keyof typeof typeGroups): boolean {
    return typeGroups[group].has(type as ElementType);
  }

  public static isAhistorical(type: string): boolean {
    return this.isInGroup(type, 'ahistorical');
  }

  public static isButton(type: string): boolean {
    return this.isInGroup(type, 'button');
  }

  public static isCollection(type: string): boolean {
    return this.isInGroup(type, 'collection');
  }

  public static isDate(type: string): boolean {
    return this.isInGroup(type, 'date');
  }

  public static isFunctional(type: string): boolean {
    return this.isInGroup(type, 'functional');
  }

  public static isIndividuallySaved(type: string): boolean {
    return this.isInGroup(type, 'individuallySaved');
  }

  public static isMultiple(type: string): boolean {
    return this.isInGroup(type, 'multiple');
  }

  public static isNumber(type: string): boolean {
    return this.isInGroup(type, 'number');
  }

  public static isStandalone(type: string): boolean {
    return this.isInGroup(type, 'standalone');
  }

  public static isTable(type: string): boolean {
    return this.isInGroup(type, 'table');
  }
}